import { pnApiClient } from '@pn/services/api/pnApiClient';
import { useAuth0AuthenticationService } from '@pn/services/authentication/auth0/auth0AuthenticationService';
import { appSignalErrorLogger } from '@pn/services/loggers/appSignalErrorLogger';
import { pnApiEventLogger } from '@pn/services/loggers/pnApiEventLogger';
import { mapboxPnMap } from '@pn/services/map/mapbox';
import { stackedNotificationService } from '@pn/services/notifications/stackedNotificationService';
import { webStorageService } from '@pn/services/storage/webStorageService';

export const useAuthenticationService = useAuth0AuthenticationService;
export const apiClient = pnApiClient;
export const eventLogger = pnApiEventLogger;
export const errorLogger = appSignalErrorLogger;
export const notificationService = stackedNotificationService;
export const map = mapboxPnMap;
export const ls = webStorageService('pn');

/**
 * @deprecated
 */
export const notify = notificationService.notify;
